import { Action } from '@ngrx/store'

export const INIT = '[Orders] Init'
export const INIT_SKIPPED = '[Orders] Init Skipped'
export const INIT_SUCCESS = '[Orders] Init Success'
export const INIT_FAILED = '[Orders] Init Failed'

export class Init implements Action {
    readonly type = INIT
}
export class InitSkipped implements Action {
    readonly type = INIT_SKIPPED
}
export class InitSuccess implements Action {
    readonly type = INIT_SUCCESS
}
export class InitFailed implements Action {
    readonly type = INIT_FAILED
}

export type Actions =
    Init
    | InitSkipped
    | InitSuccess
    | InitFailed